import { useParams } from "react-router";

import { DashboardPowerBiByCode } from "../components/DashboardPowerBiByCode";

export function PowerBiPage() {
  const { code } = useParams();

  return <DashboardPowerBiByCode code={code ?? ""} />;
}
